import { toCx } from '../../../classname.js';
import { flexWrapMap, flexShrinkMap, flexGrowMap, flexDirectionMap, flexMap, alignSelfMap, justifyContentMap, alignContentMap, alignItemsMap } from '../../../mappers.mappings.js';

var flexBoxStyleMapper = {
  alignItems: function alignItems(value, _) {
    return {
      classNames: [alignItemsMap[value]]
    };
  },
  alignContent: function alignContent(value, _) {
    return {
      classNames: [alignContentMap[value]]
    };
  },
  justifyContent: function justifyContent(value, _) {
    return {
      classNames: [justifyContentMap[value]]
    };
  },
  alignSelf: function alignSelf(value, _) {
    return {
      classNames: [alignSelfMap[value]]
    };
  },
  gap: function gap(_gap, _) {
    return {
      classNames: [toCx('gap', _gap)]
    };
  },
  flex: function flex(value, _) {
    return {
      classNames: [flexMap[value]]
    };
  },
  flexDirection: function flexDirection(value, _) {
    return {
      classNames: [flexDirectionMap[value]]
    };
  },
  flexGrow: function flexGrow(value, _) {
    return {
      classNames: [flexGrowMap[value]]
    };
  },
  flexShrink: function flexShrink(value, _) {
    return {
      classNames: [flexShrinkMap[value]]
    };
  },
  flexWrap: function flexWrap(value, _) {
    return {
      classNames: [flexWrapMap[value]]
    };
  },
  flexBasis: function flexBasis(value, _) {
    return {
      style: {
        flexBasis: value
      }
    };
  },
  order: function order(value, _) {
    return {
      style: {
        order: value
      }
    };
  }
};

export { flexBoxStyleMapper };
//# sourceMappingURL=flexbox.js.map
